import { render, staticRenderFns } from "./GroupMemberCard.vue?vue&type=template&id=16c56b0f&scoped=true&"
import script from "./GroupMemberCard.vue?vue&type=script&lang=ts&"
export * from "./GroupMemberCard.vue?vue&type=script&lang=ts&"
import style0 from "./GroupMemberCard.vue?vue&type=style&index=0&id=16c56b0f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16c56b0f",
  null
  
)

export default component.exports